import styled, { css } from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledTypography,
} from '@pkg/primitives';

import { tokens } from './AssetCard.tokens';

const expandedVars = css`
    --asset-card-row-expand-height: ${tokens.row.expandedHeight}px;
    --asset-card-row-expand-opacity: 1;
    --asset-card-row-expand-visibility: visible;
`;

interface StyledAssetCardProps {
    $expand?: boolean;
}

interface RowProps {
    $expandable?: boolean;
}

export const StyledAssetCard = styled.div<StyledAssetCardProps>`
    --asset-card-row-expand-height: 0;
    --asset-card-row-expand-opacity: 0;
    --asset-card-row-expand-visibility: hidden;

    padding: ${tokens.padding}px;
    background-color: rgb(255, 255, 255, 0.06);
    border-radius: ${tokens.radius}px;
    transition: background-color ${duration.normal}ms ${easing.cubic};

    &:hover,
    &:focus-within {
        ${expandedVars};
        background-color: rgb(255, 255, 255, 0.1);
    }

    ${({ $expand }) => $expand && expandedVars};
`;

export const Row = styled.div<RowProps>`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${tokens.padding}px;

    // TODO: This will need to be revised so we can programmatically
    // set which <AssetCard /> is currently visible.
    ${({ $expandable }) =>
        $expandable &&
        css`
            max-height: var(--asset-card-row-expand-height);
            opacity: var(--asset-card-row-expand-opacity);
            visibility: var(--asset-card-row-expand-visibility);
            overflow: hidden;
            transition-property: max-height, opacity, visibility;
            transition-duration: ${duration.normal}ms;
            transition-timing-function: ${easing.cubic};
        `};
`;

export const AssetDetailsWrapper = styled.div`
    // This should only be applied to "editable" variants.
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        max-width: 40%;
    }
`;

export const ChildrenWrapper = styled.div`
    display: grid;
    gap: ${tokens.padding}px;
    padding-top: ${tokens.padding}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: flex;
    }
`;

export const ErrorMessage = styled.div`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    padding-top: ${tokens.padding}px;
    font-size: ${tokens.errorMessage.fontSize}px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${designColor.red};
`;
